import {
  UPLOAD_FILE,
  UPLOAD_MULTI_FILE,
  POST_IPFS_FILE,
  API_FAIL,
  UPLOAD_ART,
} from "./actionTypes";

export const apiFail = (error) => ({
  type: API_FAIL,
  payload: error,
});

export const uploadFile = (data, callback) => ({
  type: UPLOAD_FILE,
  payload: { data, callback },
});

export const uploadArt = (data, callback) => ({
  type: UPLOAD_ART,
  payload: { data, callback },
});


export const uploadMultiFile = (data, callback) => ({
  type: UPLOAD_MULTI_FILE,
  payload: { data, callback },
});

export const postIpfsFile = (data, callback) => ({
  type: POST_IPFS_FILE,
  payload: { data, callback },
});
